<script lang="ts">
import { AppBlockUIComponent } from "./app-block-ui.ts";
export default AppBlockUIComponent;
</script>

<template>
    <p-block-ui
        :class="{ 'app-block-ui-blocked': blocked }"
        :blocked="blocked"
        ref="pBlockUI"
    >
        <slot v-if="blocked" />
        <slot v-else />
    </p-block-ui>
</template>
